import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import classnames from 'classnames';
import Text from '../text/text';
import './_saved-item.scss';
import { DELETE_TEXT } from '../../../constants/common-labels.constants';

interface IProps {
    intl: IntlShape;
    name: string;
    onSelect: () => void;
    onDelete: () => void;
    isSelected: boolean;
}

const SavedItem = injectIntl((props: IProps) => {
    const { intl, name, isSelected, onSelect, onDelete } = props;
    const [isDeleteHovered, setIsDeleteHovered] = useState(false);

    const handleDeleteClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        onDelete();
    };

    return (
        <div
            className={classnames('saved-item', {
                'saved-item--delete-hovered': isDeleteHovered,
                'saved-item--selected': isSelected
            })}
            onClick={onSelect}
        >
            <Text tag='div' className='saved-item__label' message={name} withEllipsis />
            <div
                className={classnames('saved-item__delete', {
                    'saved-item__delete-hovered': isDeleteHovered
                })}
                onClick={e => handleDeleteClick(e)}
                onMouseEnter={() => setIsDeleteHovered(true)}
                onMouseLeave={() => setIsDeleteHovered(false)}
            >
                {intl.formatMessage(DELETE_TEXT)}
            </div>
        </div>
    );
});

export default SavedItem;
